import { memo, useMemo } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import SectionContentSide from "./section-content-side";
import CardWithIcon from "../card-with-icon";
import { useI18n } from "@/i18n/I18nProvider";

const INNER_GRID_SX = { justifyContent: "flex-end" };

function WhyContact({ whycontactData }) {
  const { locale } = useI18n();
  const content = useMemo(() => {
    if (!whycontactData?.[0]) return null;

    const data = whycontactData[0];

    return {
      title: data?.title.text[locale],
      titleType: data?.title.type,
      subtitle: data?.intro_text.text[locale],
      subtitleType: data?.intro_text.type,
      description: data?.description.text[locale],
      descType: data?.description.type,
      iconsWithTexts: data?.items?.map((item) => ({
        icon: item.icon,
        text: item.title.text[locale],
        textType: item.title.type,
      })),
    };
  }, [whycontactData, locale]);
  const iconsWithTexts = content?.iconsWithTexts ?? [];

  // Create stable keys (prefer id/text/icon if available)
  const normalized = useMemo(() => {
    return iconsWithTexts.map((item, idx) => ({
      ...item,
      __key: item?.id ?? item?.text ?? item?.icon ?? idx,
    }));
  }, [iconsWithTexts]);

  return (
    <Box
      className="horizontal-safe-padding vertical-safe-padding"
      component="section"
    >
      <Grid container spacing={{ xs: 4, md: 4 }} alignItems="center">
        <Grid item xs={12} md={6}>
          <SectionContentSide content={content} />
        </Grid>

        <Grid item xs={12} md={6}>
          <Grid container spacing={0.7} sx={INNER_GRID_SX}>
            {normalized.map(({ icon, text, __key }) => (
              <Grid item xs={12} sm={6} key={__key}>
                <CardWithIcon icon={icon} content={text} />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default memo(WhyContact);
